import React, {HTMLAttributes} from 'react';
import {AccordionLocalizedHeadline, AccordionWrapper} from './Accordion.style';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
    readonly localizedHeadline: string;
}

/**
 * @name Accordion
 * @description
 * Generic component to create show an accordion with header and closable content area
 */
export const Accordion = React.forwardRef<HTMLDivElement, AccordionProps>(
    ({localizedHeadline, children}, ref) => {

        return (
            <AccordionWrapper id={generateIdentifier()} ref={ref}>
                <AccordionLocalizedHeadline id={generateIdentifier()}
                                            className='a-accordion__headline__localized'>
                    {localizedHeadline}
                </AccordionLocalizedHeadline>
                {children}
            </AccordionWrapper>
        );
    }
);

Accordion.displayName = 'Accordion';
